import { inject } from '@angular/core'
import { CanActivateFn, GuardResult, Router } from '@angular/router'
import { map, Observable, of, switchMap } from 'rxjs'
import { AuthService } from '../services/auth/auth.service'

const debug = false

/**
 * Check if user is logged in, try (and wait for) a token refresh if necessary.
 * Otherwise, (logged out and no refresh token) redirect to root path "/".
 */
export const AuthGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.getAuthResult().pipe(
    switchMap((authResult): Observable<GuardResult> => {
      if (authService.isLoggedIn() && authResult?.access_token) {
        if (debug) {
          console.log('[AuthGuard] Is logged in.')
        }
        return of(true)
      }
      if (authResult?.refresh_token) {
        if (debug) {
          console.log('[AuthGuard] Refresh token for ' + state.url.toString())
        }

        return authService.refreshSession().pipe(
          map((result) => {
            if (debug) {
              console.log(
                `[AuthGuard] Refresh result success=${result?.success}`
              )
            }
            return result?.success ?? router.createUrlTree(['/'])
          })
        )
      }

      if (debug) {
        console.log('[AuthGuard] create url tree ')
      }
      return of(router.createUrlTree(['/']))
    })
  )
}
